/*
    This service dynamically load the microfrontend applications to widow object
*/

import { shouldLoadMFE } from '../utils/mfeJobCodeValidation';

export const microfrontendApplicationsLoadService = async (
  ApplicationName,
  userProfileData = null
) => {
  try {
    // Handle dashboard and route suffixes by mapping back to original MFE name
    let actualMfeName = ApplicationName;
    if (ApplicationName.endsWith('-dashboard') || ApplicationName.endsWith('-route')) {
      actualMfeName = ApplicationName.replace(/-dashboard$|-route$/, '');
    }

    // Get MFE config for validation
    const mfeConfig = await window['@MFEConfig'];

    if (mfeConfig?.MFES && userProfileData) {
      const mfe = mfeConfig.MFES[actualMfeName];
      const userRole = userProfileData.userApplicationRole;
      const userJobProfileId = userProfileData.jobProfileId;

      if (mfe && !shouldLoadMFE(mfe, userRole, userJobProfileId)) {
        console.log('MFE blocked from loading:', actualMfeName);
        return {
          bootstrap: () => Promise.resolve(),
          mount: () => Promise.resolve(),
          unmount: () => Promise.resolve()
        };
      }
    }

    return await window[actualMfeName]();
  } catch (error) {
    console.log('Error occured while loading application: ', error);
    return {
      bootstrap: () => Promise.resolve(),
      mount: () => Promise.resolve(),
      unmount: () => Promise.resolve()
    };
  }
};
